// extracted by mini-css-extract-plugin
module.exports = {"LoginWrapper":"Login_LoginWrapper__wmhja","grid":"Login_grid__34VgJ","imgWrap":"Login_imgWrap__2VzOn"};